// @flow

import type { PropsSchema, EasyAction, BasicProps } from '../../type'

import * as React from 'react'
import computeData from '../hoc/computeData'

type Props = BasicProps & {
  ruleCode: string,
  formValues: { [string]: any }
};

@computeData({ includeVisible: false })
export default class JsLogic extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      title: '逻辑代码',
      key: 'ruleCode',
      type: 'code'
    },
    'separator',
    {
      type: 'event',
      title: '成功',
      event: 'resolve'
    },
    {
      type: 'event',
      title: '失败',
      event: 'reject'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '执行',
      name: 'execute'
    }
  ];

  actionExecute = (data: void, dynamicData: any) => {
    const { ruleCode, callActions, jsEnv } = this.props
    const returnData = jsEnv.runCodeWithAdditionalCtx(ruleCode, dynamicData)
    if (returnData) {
      callActions('resolve', returnData)
    } else {
      callActions('reject')
    }
  };

  render () {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/program/JsLogic.js